import { ApiFragment } from '../record/entities/api-fragment.entity';
import { ColumnDef } from '../record/entities/column-definition.entity';
import { ColumnManagementService } from './column-management.service';

export const ConfigureOverviewColumns = (
    columnManagementService: ColumnManagementService,
    overviewId: string,
    columns: ColumnDef<ApiFragment>[],
    pinnedKeys: readonly string[]
): void =>
    columnManagementService.configure(
        overviewId,
        columns,
        columns.map(column => column.toString()),
        { pinnedKeys }
    );
